import { defineStore } from "pinia";
const useWishlistStore = defineStore("wishlist", {
  state: () => ({
    wishlist: { items_count: 0 }
  })
});
export {
  useWishlistStore
};
